export const IsRelatedSuggestion = (v) => {
    var _a;
    if (typeof v !== 'object' || v === null)
        return false;
    const obj = v;
    if (typeof obj.sourceEntityType !== 'string')
        return false;
    if (typeof obj.sourceEntityRecordId !== 'string')
        return false;
    // relatedItemsがnull/undefinedの場合も有効なメッセージとして扱う（空の提案結果）
    if (obj.relatedItems != null && !Array.isArray(obj.relatedItems))
        return false;
    // TODO:厳密化する
    // https://break-tmc.atlassian.net/browse/CREW-4249
    for (const elem of (_a = obj.relatedItems) !== null && _a !== void 0 ? _a : []) {
        if (typeof elem.entityType !== 'string')
            return false;
        if (typeof elem.entityRecordId !== 'string')
            return false;
        if (typeof elem.title !== 'string')
            return false;
        if (typeof elem.updatedBy !== 'object' || elem.updatedBy === null)
            return false;
        if (typeof elem.updatedAt !== 'string')
            return false;
    }
    return true;
};
